import {newsConstants} from '../_constants';

export function blogs(state = {}, action) {
  switch (action.type) {
    case newsConstants.GET_ALL_BLOGS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case newsConstants.GET_ALL_BLOGS_SUCCESS:
      return {
        ...state,
        ...action.data,
        loading: false,
      };
    case newsConstants.GET_ALL_BLOGS_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}
